module.exports = __webpack_public_path__ + "static/media/edi3.07da8806.jpeg";